import {Component, inject} from '@angular/core';
import {Button} from 'primeng/button';
import {GameStore} from '../../store/game.store';
import {ResourcesService} from '../../services/resources.service';
import {QuestionsComponent} from '../../components/questions/questions.component';
import {ScoreBarComponent} from '../../components/score-bar/score-bar.component';
import {HintComponent} from '../../components/hint/hint.component';
import {AnswerComponent} from '../../components/answer/answer.component';
import {PanelComponent} from '../../components/panel/panel.component';
import {QuestionFeedbackComponent} from '../../components/question-feedback/question-feedback.component';
import {PanelButtonIcon} from '../../models/panel-button-icon.model';

@Component({
  selector: 'gis-playing-screen',
  imports: [
    Button,
    QuestionsComponent,
    ScoreBarComponent,
    HintComponent,
    AnswerComponent,
    PanelComponent,
    QuestionFeedbackComponent,
    QuestionsComponent
  ],
  templateUrl: './playing-screen.component.html',
  styleUrl: './playing-screen.component.scss'
})
export class PlayingScreenComponent {
  protected readonly store = inject(GameStore);
  protected readonly resourcesService = inject(ResourcesService);

  protected readonly PanelButtonIcon = PanelButtonIcon;
}
